import type { RouteObject } from 'react-router';

import { SHIFTS_PATH } from '../../app/config';

/**
 * W4 "Mes quarts" and W5 "Détail du quart", as route data for the router.
 *
 * The feature exports routes rather than editing `app/router.tsx`: the router
 * owns the authorization nesting (a session, then a PIN that is not overdue,
 * then the shell) and a feature reaching into it could mount a payroll screen
 * outside a guard.
 *
 * Both modules are lazy, and separately: W5 is only ever opened from a row on
 * W4, so the list screen should not carry the punch journal, the adjustment
 * ledger and their formatting into the first paint.
 */
export const shiftsRoutes: RouteObject[] = [
  {
    path: SHIFTS_PATH,
    lazy: async () => ({ Component: (await import('./MyShiftsPage')).MyShiftsPage }),
  },
  {
    path: `${SHIFTS_PATH}/:shiftId`,
    lazy: async () => ({ Component: (await import('./ShiftDetailPage')).ShiftDetailPage }),
  },
];

/** The name the feature brief asks every feature to export. Same array. */
export const routes = shiftsRoutes;
